import React from "react";
import AsianGame from "../asianGame";
import { t } from "../../../helpers/translator";

export default function asianGameListCompetitionTemplate () {
    let { competition, selectorKey, marketsSelectorKey, gameType, sportAlias } = this.props;
    return [
        <h4 key={competition.key} className="a-games-list-container comp-titie">
            {`${competition.regionName} / ${competition.key}`}
            {
                this.props.teams_reversed ? <span> ({t("american display")})</span> : null
            }
        </h4>,
        competition[competition.key].map((gameId) => {
            return [
                <AsianGame gameId={gameId}
                    key={gameId}
                    selectorKey={selectorKey}
                    marketsSelectorKey={marketsSelectorKey}
                    gameType={gameType}
                    sportAlias={sportAlias}
                />
            ];
        })
    ];
}